// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetSelectGroup_container__23DNZ","content":"WidgetSelectGroup_content__2Kd9m","select":"WidgetSelectGroup_select__30LT-"};